import React from "react";
import styles from "./Footer.module.scss";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <section className={styles.footer_main}>
      <section className={styles.footer_logo_section}>
        <svg
          width="60"
          height="60"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M25 0C32.0711 0 35.607 -0.000409126 37.8037 2.19629C40.0004 4.39299 40 7.92893 40 15V25C40 32.0711 40.0004 35.607 37.8037 37.8037C35.607 40.0004 32.0711 40 25 40H15C7.92893 40 4.39299 40.0004 2.19629 37.8037C-0.000409126 35.607 0 32.0711 0 25V15C0 7.92893 -0.00041008 4.39299 2.19629 2.19629C4.39299 -0.00041008 7.92893 0 15 0H25Z"
            fill="#6570FC"
          />
          <path
            d="M7.15322 23.8628C6.94156 21.5237 6.98526 19.2205 7.07027 16.9288C7.21864 12.9293 9.91102 9.46718 13.8856 8.33175C14.7071 8.09705 15.5421 7.99419 16.3969 8.00025C18.2139 8.01314 20.0312 7.99526 21.8481 8.0118C25.8681 8.04841 29.6932 11.1891 30.5547 15.1264C30.7523 16.03 30.8363 16.9398 30.8382 17.8601C30.842 19.7159 30.8366 21.5718 30.84 23.4276C30.8414 24.1451 30.831 24.8731 30.6092 25.5506C30.4014 26.1856 30.5235 26.6065 31.0046 27.0713C31.8713 27.9086 32.1641 28.9943 31.9139 30.1665C31.3244 32.9294 28.0948 33.9381 26.0382 31.9876C25.5708 31.5444 25.1852 31.3851 24.5789 31.616C23.9891 31.8407 23.3431 31.858 22.7176 31.8542C20.4261 31.8402 18.1319 31.957 15.8434 31.7936C12.0069 31.5198 9.36368 29.53 7.78678 26.0566C7.47637 25.3729 7.29719 24.645 7.15322 23.8628ZM12.4704 16.3721C11.6027 17.9609 11.3482 19.659 11.7371 21.4117C12.5376 25.0197 15.4425 27.3169 19.1407 27.3294C19.8781 27.3319 20.5891 27.4704 21.2917 27.6734C22.8756 28.1308 24.1465 29.0716 25.2384 30.2755C25.4856 30.5481 25.699 30.5824 26.0278 30.4114C27.3763 29.7098 28.435 28.7109 29.1984 27.3976C29.6642 26.5964 29.6761 26.5751 29.0093 25.9534C27.6305 24.6678 26.7507 23.1112 26.4579 21.2479C26.3264 20.4116 26.35 19.5501 26.2083 18.7162C25.662 15.5007 23.3179 13.116 20.1183 12.6139C16.9232 12.1124 14.0531 13.5831 12.4704 16.3721Z"
            fill="white"
          />
        </svg>
        <p>QREATIVES</p>
      </section>

      <section className={styles.footer_navigation_section}>
        <p>Navigation</p>

        <div className={styles.footer_links}>
          <section className={styles.footer_link_section}>
            <Link className={styles.footer_link} to="/about">
              About
            </Link>
            <Link className={styles.footer_link} to="/careers">
              Careers
            </Link>
            <Link className={styles.footer_link} to="/advertising">
              Advertising
            </Link>
            <Link className={styles.footer_link} to="/small-business">
              Small Business
            </Link>
          </section>
          <section className={styles.footer_link_section}>
            <Link className={styles.footer_link} to="/talent-solutions">
              Talent Solutions
            </Link>
            <Link className={styles.footer_link} to="/marketing-solutions">
              Marketing Solutions
            </Link>
            <Link className={styles.footer_link} to="/sales-solutions">
              Sales Solutions
            </Link>
            <Link className={styles.footer_link} to="/safety-center">
              Safety Center
            </Link>
          </section>
          <section className={styles.footer_link_section}>
            <Link className={styles.footer_link} to="/community-guidelines">
              Community Guidelines
            </Link>
            <Link className={styles.footer_link} to="/privacy-terms">
              Privacy & Terms
            </Link>
            <Link className={styles.footer_link} to="/mobile-app">
              Mobile App
            </Link>
          </section>
        </div>
      </section>

      <section className={styles.footer_fast_access_section}>
        <div className={styles.footer_fast_access_heading}>
          <p>Fast Access</p>
        </div>
        <div className={styles.footer_fast_access_buttons}>
          <button className={styles.footer_fast_access_question}>
            <p>QUESTIONS?</p>

            <svg
              width="18"
              height="18"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_266_16)">
                <path
                  d="M8.00065 14.6667C11.6825 14.6667 14.6673 11.6819 14.6673 8.00004C14.6673 4.31814 11.6825 1.33337 8.00065 1.33337C4.31875 1.33337 1.33398 4.31814 1.33398 8.00004C1.33398 11.6819 4.31875 14.6667 8.00065 14.6667Z"
                  stroke="white"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M6.06055 6.00001C6.21728 5.55446 6.52665 5.17875 6.93385 4.93944C7.34105 4.70012 7.81981 4.61264 8.28533 4.69249C8.75085 4.77234 9.17309 5.01436 9.47726 5.3757C9.78144 5.73703 9.94792 6.19436 9.94721 6.66668C9.94721 8.00001 7.94721 8.66668 7.94721 8.66668"
                  stroke="white"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M8 11.3334H8.00667"
                  stroke="white"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </g>
              <defs>
                <clipPath id="clip0_266_16">
                  <rect width="16" height="16" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </button>
          <button className={styles.footer_fast_access_search}>
            SETTINGS
            <svg
              width="18"
              height="18"
              viewBox="0 0 17 17"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g clipPath="url(#clip0_266_23)">
                <path
                  d="M8.57812 10.1519C9.68269 10.1519 10.5781 9.25643 10.5781 8.15186C10.5781 7.04729 9.68269 6.15186 8.57812 6.15186C7.47356 6.15186 6.57812 7.04729 6.57812 8.15186C6.57812 9.25643 7.47356 10.1519 8.57812 10.1519Z"
                  stroke="#6570fc"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M13.5108 10.1518C13.4221 10.3529 13.3956 10.5759 13.4348 10.7922C13.474 11.0085 13.5771 11.208 13.7308 11.3651L13.7708 11.4051C13.8948 11.529 13.9931 11.676 14.0602 11.8379C14.1273 11.9998 14.1619 12.1733 14.1619 12.3485C14.1619 12.5237 14.1273 12.6972 14.0602 12.8591C13.9931 13.0209 13.8948 13.168 13.7708 13.2918C13.647 13.4158 13.4999 13.5141 13.3381 13.5812C13.1762 13.6483 13.0027 13.6829 12.8275 13.6829C12.6523 13.6829 12.4788 13.6483 12.3169 13.5812C12.155 13.5141 12.008 13.4158 11.8841 13.2918L11.8441 13.2518C11.687 13.0981 11.4875 12.995 11.2712 12.9558C11.0549 12.9166 10.8319 12.9431 10.6308 13.0318C10.4336 13.1163 10.2655 13.2566 10.147 13.4355C10.0286 13.6144 9.965 13.824 9.96414 14.0385V14.1518C9.96414 14.5054 9.82366 14.8446 9.57362 15.0946C9.32357 15.3447 8.98443 15.4851 8.63081 15.4851C8.27718 15.4851 7.93805 15.3447 7.688 15.0946C7.43795 14.8446 7.29747 14.5054 7.29747 14.1518V14.0918C7.29231 13.8712 7.22089 13.6571 7.09248 13.4776C6.96408 13.2981 6.78463 13.1613 6.57747 13.0851C6.3764 12.9964 6.15334 12.9699 5.93708 13.0091C5.72082 13.0484 5.52126 13.1515 5.36414 13.3051L5.32414 13.3451C5.20031 13.4691 5.05326 13.5675 4.89139 13.6346C4.72953 13.7017 4.55603 13.7362 4.38081 13.7362C4.20559 13.7362 4.03208 13.7017 3.87022 13.6346C3.70836 13.5675 3.5613 13.4691 3.43747 13.3451C3.31351 13.2213 3.21516 13.0743 3.14806 12.9124C3.08096 12.7505 3.04642 12.577 3.04642 12.4018C3.04642 12.2266 3.08096 12.0531 3.14806 11.8912C3.21516 11.7294 3.31351 11.5823 3.43747 11.4585L3.47747 11.4185C3.63116 11.2614 3.73426 11.0618 3.77348 10.8455C3.81269 10.6293 3.78622 10.4062 3.69747 10.2051C3.61297 10.008 3.47264 9.8398 3.29378 9.72135C3.11492 9.6029 2.90533 9.53934 2.69081 9.53848H2.57747C2.22385 9.53848 1.88471 9.398 1.63466 9.14796C1.38462 8.89791 1.24414 8.55877 1.24414 8.20515C1.24414 7.85153 1.38462 7.51239 1.63466 7.26234C1.88471 7.01229 2.22385 6.87181 2.57747 6.87181H2.63747C2.85814 6.86665 3.07214 6.79523 3.25167 6.66682C3.4312 6.53842 3.56795 6.35897 3.64414 6.15181C3.73288 5.95074 3.75936 5.72769 3.72014 5.51142C3.68093 5.29516 3.57783 5.0956 3.42414 4.93848L3.38414 4.89848C3.26017 4.77465 3.16183 4.6276 3.09473 4.46573C3.02763 4.30387 2.99309 4.13037 2.99309 3.95515C2.99309 3.77993 3.02763 3.60642 3.09473 3.44456C3.16183 3.2827 3.26017 3.13565 3.38414 3.01181C3.50797 2.88785 3.65502 2.7895 3.81689 2.7224C3.97875 2.6553 4.15225 2.62077 4.32747 2.62077C4.50269 2.62077 4.6762 2.6553 4.83806 2.7224C4.99992 2.7895 5.14698 2.88785 5.27081 3.01181L5.31081 3.05181C5.46793 3.20551 5.66748 3.3086 5.88375 3.34782C6.10001 3.38703 6.32306 3.36056 6.52414 3.27181H6.57747C6.77465 3.18731 6.94282 3.04698 7.06127 2.86812C7.17972 2.68926 7.24328 2.47967 7.24414 2.26515V2.15181C7.24414 1.79819 7.38462 1.45905 7.63466 1.20901C7.88471 0.958957 8.22385 0.818481 8.57747 0.818481C8.9311 0.818481 9.27023 0.958957 9.52028 1.20901C9.77033 1.45905 9.91081 1.79819 9.91081 2.15181V2.21181C9.91166 2.42634 9.97523 2.63593 10.0937 2.81479C10.2121 2.99365 10.3803 3.13397 10.5775 3.21848C10.7786 3.30722 11.0016 3.3337 11.2179 3.29448C11.4341 3.25527 11.6337 3.15217 11.7908 2.99848L11.8308 2.95848C11.9546 2.83451 12.1017 2.73617 12.2636 2.66907C12.4254 2.60197 12.5989 2.56743 12.7741 2.56743C12.9494 2.56743 13.1229 2.60197 13.2847 2.66907C13.4466 2.73617 13.5936 2.83451 13.7175 2.95848C13.8414 3.08231 13.9398 3.22936 14.0069 3.39123C14.074 3.55309 14.1085 3.72659 14.1085 3.90181C14.1085 4.07704 14.074 4.25054 14.0069 4.4124C13.9398 4.57427 13.8414 4.72132 13.7175 4.84515L13.6775 4.88515C13.5238 5.04227 13.4207 5.24183 13.3815 5.45809C13.3423 5.67435 13.3687 5.8974 13.4575 6.09848V6.15181C13.542 6.34899 13.6823 6.51716 13.8612 6.63561C14.04 6.75406 14.2496 6.81763 14.4641 6.81848H14.5775C14.9311 6.81848 15.2702 6.95896 15.5203 7.20901C15.7703 7.45905 15.9108 7.79819 15.9108 8.15181C15.9108 8.50544 15.7703 8.84457 15.5203 9.09462C15.2702 9.34467 14.9311 9.48515 14.5775 9.48515H14.5175C14.3029 9.486 14.0934 9.54957 13.9145 9.66802C13.7356 9.78647 13.5953 9.95463 13.5108 10.1518V10.1518Z"
                  stroke="#6570fc"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </g>
              <defs>
                <clipPath id="clip0_266_23">
                  <rect
                    width="16"
                    height="16"
                    fill="white"
                    transform="translate(0.578125 0.151855)"
                  />
                </clipPath>
              </defs>
            </svg>
          </button>
        </div>
      </section>
      <section className={styles.footer_language_section}>
        <div className={styles.footer_language_heading}>
          <p>Language</p>
        </div>
        <div className={styles.footer_language_select}>
          <select name="" id="">
            <option value="">Select Language</option>
            <option value="english">English</option>
            <option value="hindi">Hindi</option>
            <option value="marathi">Marathi</option>
          </select>
        </div>
      </section>
    </section>
  );
};

export default Footer;
